import { apiFetch } from './http';

// ─────────────────────────────────────────────────────────────────────
// «AVSLUTT KONTOEN» — the client for `POST /me/close` (#1062).
//
// The account comes from the session; nothing is sent. The server revokes
// every session the account holds, this one included, so a caller treats a
// success as «signed out» and leaves the signed-in surface.
//
// A 403 `reauthentication_required` is ALSO reported by the transport, which
// opens the step-up prompt (`lib/api/http.ts`); the caller just shows the code
// and lets the person press again once they have confirmed.
// ─────────────────────────────────────────────────────────────────────

export interface CloseAccountOutcome {
  /** A machine code from the API, or null when the account is now closed. Never a sentence. */
  code: string | null;
}

export async function closeMyAccount(): Promise<CloseAccountOutcome> {
  let res: Awaited<ReturnType<typeof apiFetch>>;
  try {
    res = await apiFetch('/me/close', { method: 'POST' });
  } catch {
    return { code: 'unreachable' };
  }
  if (res.ok) return { code: null };
  const body = (await res.json().catch(() => null)) as { error?: unknown } | null;
  return { code: typeof body?.error === 'string' ? body.error : `http_${res.status}` };
}
